import React from 'react';
import icon from './icon-ok.svg';

import styles from './Feature.module.scss';

const Feature = ({ children }: React.PropsWithChildren) => {
  return (
    <div className={styles.feature}>
      <img src={icon} alt="" />
      <div>{children}</div>
    </div>
  );
};

export default Feature;
